import { useForm } from 'react-hook-form'
import { FormTemplate, FormTextField } from 'ComponentLibrary'
import { Box } from '@mui/material'
import { CostCenter } from 'ComponentLibrary/src/molecules/CostCenter/types'
import { useContext } from 'react'
import { PiazzaInputContext } from 'ComponentLibrary/src/molecules/Form/PiazzaInputContext'

type CostCenterFormProps = {
    onCancelCallback: () => void
    onSubmitCallback: (data: Omit<CostCenter, 'uuid'>) => void
    costCenter?: CostCenter
    labels?: Partial<CostCenterFormLabels>
}

export type CostCenterFormLabels = {
    name: string
    description: string
}

const DEFAULT_COST_CENTER_FORM_LABELS: CostCenterFormLabels = {
    name: 'Name Kostenstelle',
    description: 'Kurzbeschreibung',
}

export function CostCenterForm({ onCancelCallback, onSubmitCallback, costCenter, labels }: CostCenterFormProps) {
    const usePiazzaInputs = useContext(PiazzaInputContext)
    const resolvedLabels = { ...DEFAULT_COST_CENTER_FORM_LABELS, ...labels }
    const {
        control,
        handleSubmit,
        formState: { errors, isDirty },
        reset,
    } = useForm<Omit<CostCenter, 'uuid'>>({
        defaultValues: {
            name: costCenter?.name,
            description: costCenter?.description,
        },
    })

    const onSubmit = handleSubmit((costCenter) => {
        costCenter.name && onSubmitCallback(costCenter)
    })

    const onCancel = () => {
        reset()
        onCancelCallback()
    }

    return (
        <Box>
            <FormTemplate onSubmit={onSubmit} onCancel={onCancel} isFormDirty={isDirty} dense={usePiazzaInputs}>
                <FormTextField control={control} fieldName="name" errors={errors} label={resolvedLabels.name} xs={6} required />
                <FormTextField control={control} fieldName="description" errors={errors} label={resolvedLabels.description} xs={6} />
            </FormTemplate>
        </Box>
    )
}
